import { render, staticRenderFns } from "./TheNavigationBaseV2.vue?vue&type=template&id=6cb7dfdd"
import script from "./TheNavigationBaseV2.vue?vue&type=script&lang=ts"
export * from "./TheNavigationBaseV2.vue?vue&type=script&lang=ts"
import style0 from "./TheNavigationBaseV2.vue?vue&type=style&index=0&id=6cb7dfdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports